import React, { Component } from 'react';
import API from '../../../api/api';
import './alipayTransfer.less';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import { Table, Button, DatePicker, message, ConfigProvider, Select, Input, Modal } from 'antd';
const { RangePicker } = DatePicker;
const { Option } = Select;
const key = 'updatable';

class AlipayTransfer extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        transferList: [], //导览使用 列表数据
        sumConNum: '',
        sumGroupNum: '',
        sumPromoterNum: '',
        columnsGuideList: [//导览使用数据
            {
                title: '交易单号',
                dataIndex: 'tradeId',
                key: 'tradeId',
            },
            {
                title: '支付宝账号',
                dataIndex: 'accountNum',
                key: 'accountNum',
            },
            {
                title: '提现金额',
                dataIndex: 'orderAmountstr',
                key: 'orderAmountstr',
            },
            {
                title: '平台手续费',
                dataIndex: 'serviceChargestr',
                key: 'serviceChargestr',
            },
            {
                title: '实际转账金额',
                dataIndex: 'transferAmountStr',
                key: 'transferAmountStr',
            },
            {
                title: '认证人',
                dataIndex: 'accountName',
                key: 'accountName',
            },
            {
                title: '提现时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text, record, index) => {
                    return (
                        <span>{moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
                    )
                }
            },
            {
                title: '操作时间',
                dataIndex: 'updateTime',
                key: 'updateTime',
                render: (text, record, index) => {
                    return (
                        <span>{moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
                    )
                }
            },
            {
                title: '状态',
                dataIndex: 'tradeStatus',
                key: 'tradeStatus',
                render: (text, record, index) => {
                    return (
                        <div>
                            {
                                text == 4 ? '待处理' :
                                    text == 2 ? '转账完成' :
                                        text == 5 ? '转账失败' : ''
                            }
                        </div>
                    )
                }
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
            },
            {
                title: '交易记录',
                render: (text, record, index) => {
                    return (
                        <div>
                            <Button onClick={this.payHistoryList.bind(this, record)}>查看</Button>
                        </div>
                    )
                }
            },
            {
                title: '操作',
                render: (text, record, index) => {
                    return (
                        <div>
                            {
                                record.tradeStatus == 4 &&
                                <Button type="primary" onClick={() => this.tradeStatus('single', record)}>转账</Button>
                            }
                        </div>
                    )
                }
            }
        ],
        selectedRowKeys: [],
        loading: false,

        searchCondition: {
            queryType: '1',
            payType: '3',
            accountNum: '',
            accountName: '',
            createTimeStart: '',
            createTimeEnd: '',
            updateTimeStart: '',
            updateTimeEnd: '',
            tradeStatus: '',
            isWaitHandler: '',
            pageNum: 1,
            pageRows: 10,
        },

        pagination: {
            current: 1,
            defaultCurrent: 1,
            defaultPageSize: 10,
            hideOnSinglePage: true,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30', '40'],
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0,
            showTotal: total => `总${total}条`,
        },
        modelData: {
            visible: false,
            confirmLoading: false,
            title: '确定转账信息',
            cancelText: '取消',
            okText: '确定',
            list: [
                {
                    key: '支付宝账号：',
                    value: '333'
                },
                {
                    key: '转账金额：',
                    value: '444'
                }
            ],
        },
        modelData1: {
            visible: false,
        },
        totalUserNum: 0
    }

    payHistoryList(record) {
        let url = window.location.host == 'test.im-dangdang.com' ? 'http://test.im-dangdang.com/console/' : 'https://console.im-dangdang.com/console/';
        url += `jsps/pay/payHistoryList.jsp?circleId=${record.circleId}&userId=${record.userId}&ownerId=${record.ownerId}&ownerType=${record.ownerType}`;
        window.location.href = url;
    }

    async tradeStatus(type, tradeItem, isWaitHandler) {
        let { modelData, totalUserNum, totalAmount, selectedRows } = this.state;
        let tradeParams = { tradeStatus: 1, type };
        if (type == 'part') {
            let tradeIdList = [];
            let totalAmountPart = 0;
            selectedRows && selectedRows.length > 0 && selectedRows.map((item) => {
                totalAmountPart += item.orderAmount;
                tradeIdList.push(item.tradeId)
            })
            tradeParams.tradeIdList = JSON.stringify(tradeIdList);
            this.setState({ loading: true });
            Object.assign(modelData, {
                title: '确定转账信息',
                cancelText: '取消',
                confirmLoading: false,
                visible: true,
                list: [{
                    key: '总转账人数：',
                    value: selectedRows.length
                }, {
                    key: '总转账金额：',
                    value: (totalAmountPart / 100).toFixed(2)
                }]
            })
        }

        if (type == 'all') {
            this.setState({ loadingAll: true });
            Object.assign(modelData, {
                title: '确定转账信息',
                cancelText: '取消',
                confirmLoading: false,
                visible: true,
                list: [{
                    key: '总转账人数：',
                    value: totalUserNum
                }, {
                    key: '总转账金额：',
                    value: totalAmount
                }]
            })
        }

        if (type == 'single') {
            tradeParams.tradeId = tradeItem.tradeId;
            if (isWaitHandler == '1') {
                tradeParams.isWaitHandler = isWaitHandler;
                tradeParams.tradeStatus = '';
                Object.assign(modelData, {
                    title: '确定暂不处理信息',
                    cancelText: '取消',
                    confirmLoading: false,
                    visible: true,
                    list: [{
                        key: '支付宝账号：',
                        value: tradeItem.accountNum
                    }, {
                        key: '转账金额：',
                        value: tradeItem.orderAmountstr
                    }]
                })
            } else {
                Object.assign(modelData, {
                    title: '确定转账信息',
                    cancelText: '取消',
                    confirmLoading: false,
                    visible: true,
                    list: [{
                        key: '支付宝账号：',
                        value: tradeItem.accountNum
                    }, {
                        key: '转账金额：',
                        value: tradeItem.orderAmountstr
                    }]
                })
            }
        }

        this.setState({ modelData, tradeParams })
    };


    componentDidMount() {
        this.getListData();
    }

    async getListData(type) {
        const { searchCondition, pagination } = this.state;
        let params = Object.assign({}, searchCondition);
        if ('reset' == type) {
            params = {
                queryType: '1',
                payType: '3',
                accountNum: '',
                accountName: '',
                createTimeStart: '',
                createTimeEnd: '',
                updateTimeStart: '',
                updateTimeEnd: '',
                tradeStatus: '',
                isWaitHandler: '',
                pageNum: 1,
                pageRows: 10,
            }
            this.setState({ searchCondition: params })
        } else {
            if (params.createTimeStart) {
                params.createTimeStart = params.createTimeStart.format('YYYY-MM-DD');
            }
            if (params.updateTimeStart) {
                params.updateTimeStart = params.updateTimeStart.format('YYYY-MM-DD');
            }
            if (params.createTimeEnd) {
                params.createTimeEnd = params.createTimeEnd.format('YYYY-MM-DD')
            }
            if (params.updateTimeEnd) {
                params.updateTimeEnd = params.updateTimeEnd.format('YYYY-MM-DD')
            }
        }
        message.loading({ content: '查询中...', key });
        console.log('searchCondition', this.state.searchCondition)
        let result = await API.transferList(params);
        if (result.status == 1) {
            message.success({ content: '成功', key, duration: 0.6 });
            let { transferList, totalNum, totalUserNum, totalAmount } = result.data;
            if (!transferList) {
                pagination.total = 0;
                pagination.current = searchCondition.pageNum;
                this.setState({
                    totalUserNum: 0,
                    totalAmount: 0,
                    transferList: [],
                    pagination
                })
                return
            }
            pagination.total = Number(totalNum);
            pagination.current = searchCondition.pageNum;
            this.setState({
                totalUserNum: Number(totalUserNum),
                totalAmount,
                transferList,
                pagination
            })
            return
        }
        message.error({ content: result.msg, key, duration: 1 });
    }

    onSearchDateChange(type, date, dateStrings) {
        let { searchCondition } = this.state;
        console.log('date', date, dateStrings)
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = ''; endTime = '';
        } else {
            startTime = date[0]
            endTime = date[1]
        }
        if (type == 1) {
            searchCondition.createTimeStart = startTime;
            searchCondition.createTimeEnd = endTime;
        } else {
            searchCondition.updateTimeStart = startTime;
            searchCondition.updateTimeEnd = endTime;
        }
        this.setState({ searchCondition });
    }


    inputNumberChange(type, event) {
        let { searchCondition } = this.state;
        searchCondition[type] = event.target.value;
        this.setState({ searchCondition })
    }

    onSelectChange(value) {//下拉框更改
        let { searchCondition } = this.state
        searchCondition.tradeStatus = value;
        if (value == 1) {
            searchCondition.isWaitHandler = value;
        } else {
            searchCondition.isWaitHandler = '';
        }
        this.setState({ searchCondition })
    }

    onTableSelectChange = (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys=====`, selectedRowKeys, 'selectedRows: ', selectedRows);
        this.setState({ selectedRowKeys, selectedRows });
    };

    handleTableChange = (pagination) => {
        const { searchCondition } = this.state;
        searchCondition.pageNum = pagination.current;
        this.setState({
            pagination,
            searchCondition,
        }, () => {
            this.getListData();
        });
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = async e => {
        console.log(e);
        let { modelData, modelData1, tradeParams } = this.state;
        if (modelData1.visible) {
            modelData1.visible = false;
            this.setState({ modelData1 })
            this.getListData();
            return;
        }
        modelData.confirmLoading = true;
        this.setState({ modelData, tradeParams })
        let result = await API.tradeStatus(tradeParams);
        modelData.confirmLoading = false
        modelData.visible = false
        this.setState({ loading: false, loadingAll: false, modelData })
        if (result.status == 1) {
            // message.success({ content: '操作成功', key, duration: 0.6 });
            let modelData1 = {
                visible: true,
                confirmLoading: false,
                title: '转账完成',
                // cancelText: '取消',
                okText: '确定',
                list: [
                    {
                        key: '转账成功人数：',
                        value: `${result.data.transferSuccess}人`
                    },
                    {
                        key: '转账成功金额：',
                        value: `${result.data.transferSuccessAmount / 100}元`
                    },
                    {
                        key: '转账失败人数：',
                        value: `${result.data.transferFail}人`
                    },
                    {
                        key: '转账失败金额：',
                        value: `${result.data.transferFailAmount / 100}元`
                    },
                ],
                footer: [

                ]
            }
            if (tradeParams.type == 'part') {
                this.setState({ selectedRowKeys: [] })
            }
            this.setState({ modelData1, modelData })
            // this.getListData();
            return
        }
        message.error({ content: result.msg, key, duration: 1 });
    };

    handleCancel = e => {
        let { modelData } = this.state;
        modelData.visible = false;
        this.setState({
            modelData,
            loading: false,
            loadingAll: false
        });
    };


    async transferCsv() {
        const { searchCondition } = this.state;
        let params = Object.assign({}, searchCondition);
        if (params.createTimeStart) {
            params.createTimeStart = params.createTimeStart.format('YYYY-MM-DD');
        }
        if (params.updateTimeStart) {
            params.updateTimeStart = params.updateTimeStart.format('YYYY-MM-DD');
        }
        if (params.createTimeEnd) {
            params.createTimeEnd = params.createTimeEnd.format('YYYY-MM-DD')
        }
        if (params.updateTimeEnd) {
            params.updateTimeEnd = params.updateTimeEnd.format('YYYY-MM-DD')
        }
        await API.transferCsv(params);
    }

    render() {
        const {
            columnsGuideList,
            transferList,
            searchCondition,
            pagination,
            modelData,
            modelData1,
            selectedRows,
            totalUserNum
        } = this.state;
        const { loading, selectedRowKeys, loadingAll } = this.state;
        const rowSelection = {
            selectedRowKeys,
            fixed: true,
            onChange: this.onTableSelectChange,
            getCheckboxProps: record => ({
                disabled: record.tradeStatus != 4, // Column configuration not to be checked
                name: record.tradeId,
            }),
        };
        const hasSelected = selectedRows && selectedRows.length > 0;
        console.log('render=searchCondition', searchCondition)
        return (
            <ConfigProvider locale={zhCN}>
                <div className="alipayTransfer">
                    <div className="searchPane">
                        <div className="leftCondition">
                            <Select className="selectBlock" value={searchCondition.tradeStatus} defaultValue={searchCondition.tradeStatus} onChange={this.onSelectChange.bind(this)}>
                                <Option value={''}>全部</Option>
                                <Option value={4}>待处理</Option>
                                <Option value={2}>转账完成</Option>
                                <Option value={5}>转账失败</Option>
                            </Select>
                            <div className='rangePickerModel'>
                                <label>提现时间</label>
                                <RangePicker
                                    // placeholder={['开始日期', '结束日期']}
                                    className="rangePicker"
                                    value={[searchCondition.createTimeStart ? searchCondition.createTimeStart : null, searchCondition.createTimeEnd ? searchCondition.createTimeEnd : null]}
                                    onChange={this.onSearchDateChange.bind(this, '1')}
                                ></RangePicker>
                            </div>
                            <div className='rangePickerModel'>
                                <label>操作时间</label>
                                <RangePicker
                                    // placeholder={['开始日期', '结束日期']}
                                    className="rangePicker"
                                    value={[searchCondition.updateTimeStart ? searchCondition.updateTimeStart : null, searchCondition.updateTimeEnd ? searchCondition.updateTimeEnd : null]}
                                    onChange={this.onSearchDateChange.bind(this, '2')}
                                ></RangePicker>
                            </div>
                            <div className='InputNumber'>
                                <Input
                                    placeholder='支付宝账号'
                                    type='text'
                                    value={searchCondition.accountNum}
                                    onChange={this.inputNumberChange.bind(this, 'accountNum')} />
                            </div>
                            <div className='InputNumber'>
                                <Input
                                    placeholder='认证人'
                                    type='text'
                                    value={searchCondition.accountName}
                                    onChange={this.inputNumberChange.bind(this, 'accountName')} />
                            </div>
                            <Button onClick={this.getListData.bind(this)}>搜索</Button>
                            <Button onClick={this.getListData.bind(this, 'reset')}>重置</Button>
                            <Button onClick={this.transferCsv.bind(this)}>导出数据</Button>
                        </div>
                    </div>
                    <Button type="primary" onClick={() => this.tradeStatus('part')} disabled={!hasSelected} loading={loading}>向选中用户转账</Button>
                    <Button type="primary" onClick={() => this.tradeStatus('all')} disabled={Number(totalUserNum) == 0} loading={loadingAll}>向全部用户转账</Button>
                    <Table
                        rowSelection={rowSelection}
                        columns={columnsGuideList}
                        dataSource={transferList}
                        pagination={pagination}
                        scroll={{ x: true, scrollToFirstRowOnChange: true }}
                        onChange={this.handleTableChange}
                        rowKey={(row, index) => index}
                    />
                    <Modal
                        title={modelData.title}
                        visible={modelData.visible}
                        confirmLoading={modelData.confirmLoading}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        footer={modelData.footer}
                    >
                        {
                            modelData.list.map((item) => {
                                return (
                                    <p key={item.key}>
                                        <span>{item.key}</span>
                                        <span>{item.value}</span>
                                    </p>
                                )
                            })
                        }
                    </Modal>
                    <Modal
                        title='转账完成'
                        visible={modelData1.visible}
                        onOk={this.handleOk}
                        footer={[
                            <Button key="submit" type="primary" onClick={this.handleOk}>确定</Button>
                        ]}
                    >
                        {
                            modelData1.list && modelData1.list.map((item) => {
                                return (
                                    <p key={item.key}>
                                        <span>{item.key}</span>
                                        <span>{item.value}</span>
                                    </p>
                                )
                            })
                        }
                    </Modal>
                </div>
            </ConfigProvider>
        )
    }
}

export default AlipayTransfer;